module.exports = __webpack_public_path__ + "img/cns_pc6.b0b7589b.png";